import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { StageGetCollectionByProjectIds, StageGetCollectionByProjectIdsResponse } from '../../api/dtos';


const getData = (response?: SWRResponse<StageGetCollectionByProjectIdsResponse, StageGetCollectionByProjectIdsResponse>) => response?.data?.stages;
const getError = (response?: SWRResponse<StageGetCollectionByProjectIdsResponse, StageGetCollectionByProjectIdsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useStagesByProjectIds = (projectIds?: number[], skip?: number, take?: number, configuration?: SWRConfiguration<StageGetCollectionByProjectIdsResponse, StageGetCollectionByProjectIdsResponse>) => {
    
    const request = useMemo(() => {

        return projectIds && projectIds.length > 0 ?
            () => {
                return new StageGetCollectionByProjectIds({ projectIds });
            } :
            undefined;
    }, [projectIds, skip, take])

    return useGet(request, { getData, getError}, configuration);
}

export default useStagesByProjectIds;